import { render } from "./DeleteAPForm.vue?vue&type=template&id=be8647f8&scoped=true&lang=pug"
import script from "./DeleteAPForm.vue?vue&type=script&lang=ts"
export * from "./DeleteAPForm.vue?vue&type=script&lang=ts"

import "./DeleteAPForm.vue?vue&type=style&index=0&id=be8647f8&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-be8647f8"

export default script